import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
//import { PurchaseEvents } from './PurchaseEvents';
import {
  SalesOrderService,
  ComboService,
  Combo2Service
} from "../../../services/index";

@Component({
  selector: "addEdit-SalesReturn-Bundle",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./add_factorydel_plan.html",
})
export class addFactorydelPlan {
  teamList = ["PRIME", "PREMIUM"];
  list = [];
  agentList = [];
  mode: string;
  saveEvent: any;
  tot_qty : any;
  isLoading: boolean = false;
  month_data : any;
  finyearList = [];
  checklist = [];
  masterData: any = {
    entry_by: '',
    finyear: '',
    fin_id: '',
    effective_from: new Date()
  };
  agentData = [];
  // agentDetails= {
  //   from : '',
  //   to:'',
  //   commission:''

  // }

  @Input() _params: any;
  @Input() active = false;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designdata = Object.assign({}, val["data"]);

    if (this.mode == "View") {
      this.viewCommissionlist(designdata.fin_id)
      this.masterData = designdata;


    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private salesservice: SalesOrderService,
    private comboservice: ComboService,
    private combo2service: Combo2Service,


  ) { }
  ngOnInit() {
    
    this.getPartyList();
      this.finyearCombo();
    this.getAgentList();
    if (this.mode == "Add") {

      this.agentData = [{month: 'Jan',work_days:0,plan_qty:0,avg_qty: 0,month_key: '01'},{month: 'Feb',work_days:0,plan_qty:0,avg_qty: 0,month_key: '02'},{month: 'Mar',work_days:0,plan_qty:0,avg_qty: 0,month_key: '03'},{month: 'Apr',work_days:0,plan_qty:0,avg_qty: 0,month_key: '04'},{month: 'May',work_days:0,plan_qty:0,avg_qty: 0,month_key: '05'},{month: 'Jun',work_days:0,plan_qty:0,avg_qty: 0,month_key: '06'},{month: 'July',work_days:0,plan_qty:0,avg_qty: 0,month_key: '07'},{month: 'Aug',work_days:0,plan_qty:0,avg_qty: 0,month_key: '08'},{month: 'Sep',work_days:0,plan_qty:0,avg_qty: 0,month_key: '09'},{month: 'Oct',work_days:0,plan_qty:0,avg_qty: 0,month_key: '10'},{month: 'Nov',work_days:0,plan_qty:0,avg_qty: 0,month_key: '11'},{month: 'Dec',work_days:0,plan_qty:0,avg_qty: 0,month_key: '12'}];
      this.getcommissionMasterList();

    }
 

    console.log(this.agentData)
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      $("#ret_date").focus();
    }, 100);
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);

    }
  }
  onGoToNextFld($event, fld, ind) {

  
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, ind);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };

  }
  Selectqty(i){
   this.tot_qty = 0;
   this.agentData[i].avg_qty = (this.agentData[i].plan_qty / this.agentData[i].work_days).toFixed(0);
    this.agentData.forEach(e => {
      this.tot_qty += e.plan_qty
    });
    
}


  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

 
  finyearCombo(){
    this.combo2service.finyearCombo().then((res: any)=>{
      this.finyearList = res.data
      this.masterData.finyear = res.data[0].finyear;
      this.masterData.fin_id = res.data[0].fin_id;
    })
  }
  tableStyle(ind) {
    let color = ""
    if ((ind % 2) == 1) {
      color = "lightpink"
    }
    else {
      color = "bisque"
    }
    const style
      = {
      background: color
    }
    return style
  }
  getAgentList() {
    let that = this;
    that.salesservice.getAgentList({}).then((res: any) => {
      this.list = res;

    });
  }

  onSelectTeam(type) {
    let data = this.list;
    this.agentList = data.filter(el => el.incharger == type);


  }
  getcommissionMasterList() {
    let that = this;
    that.salesservice.getcommissionMasterList({}).then((res: any) => {
      this.checklist = res.data;
      console.log(this.checklist);

    });

  }

  onSelectagent(type) {
    let data = this.list;
    let obj = data.find(o => o.name === type);

    this.masterData.agent_id = obj.genLedid;

    let chekobj = this.checklist.filter(el => el.agent_name == type);

    if (chekobj.length) {
      swal("NAME ALREADY EXIST!");
    }

  }




  viewCommissionlist(id) {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      fin_id: id,
      type: 'entry_view'
    };
    this.salesservice
      .getFactoryDelplanList(params)
      .then((res: any) => {
        this.agentData = res.data;
         this.Selectqty(0)
        // console.log(this.agentData);
        // this.calctot();
        // var bottom = document.querySelector("#salesTbody");
        // bottom.scrollTop = bottom.scrollHeight;
      });
  }
  // addValue(ind){


  // }  


  oncheckemptyrow() {

    let design = this.masterData;
    let empty_check = false;

    if (!design['finyear'] || !design['effective_from']) {
      swal("PLEASE ENTER ALL THE DETAILS!");
      empty_check = true;
      // console.log(design['team'])
    }

    if (!empty_check) {

      this.onSaveOrder();
    }
  }



  onSaveOrder() {
    // debugger;
   
    let params: any = Object.assign({}, this.masterData);

    params["effective_from"] = this.datePipe.transform(
      this.masterData.effective_from,
      "yyyy-MM-dd"
    );
    params['agentData'] = JSON.stringify(this.agentData);
    params['mode'] =  this.mode;
    // params["ret_date"] = this.datePipe.transform(
    //   this.masterData.ret_date,
    //   "yyyy-MM-dd"
    // );
    let that = this;
    that.isLoading = true;
    if (that.mode == "Add" || that.mode == "View") {
      swal({
        title: "Are you sure to save this Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoading = true;
        that.salesservice
          .addFactorydelPlan(params)
          .then(function (res: any) {
            that.isLoading = false;
            if (that.saveEvent) {
              that.saveEvent.emit();
            }
            if (res.success) {
              //    that.printdata(res.printData);
              that.toasterService.pop({
                bodyOutputType: 1,
                type: "success",
                title: "SUCCESS",
                body: res.message,
              });
              if (that.mode == "Add" || that.mode == "View") {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              } else {
                let tabObj = {
                  action: "CloseTab",
                  params: {},
                };
                that.tabUpdateEvent.emit(tabObj);
              }
            } else {
              swal("ERROR", res.message, "error");
            }
          })
          .catch(function (error: any) {
            that.isLoading = false;
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/factoryDelPlan/add_factorydel_plan.ts